<template>
  <div class="foot-print-box">
    <div class="foot-print" v-for="(item,index) in dataList" :key="index">
      <div class="foot-print-top">
        <div>
          <img :src="item.avatarName" alt />
        </div>
        <div class="print-top-right">
          <p>{{item.nickName}}</p>
          <!-- <div class="top-right-source">
            <span>来源</span>
            <span>云客小店</span>
          </div> -->
        </div>
      </div>
      <div class="foot-print-bot">
        <p>最近足迹：</p>
        <p>{{item.nickName}}访问了{{item.productName}}</p>
        <p>{{item.createTime}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      dataList: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let phone = localStorage.getItem('phone')
      this.$fetchPost(URL.qryCusTrace.url, { agentPhoneNo: phone }).then((res) => {

        this.dataList = res.data.data
      })
    }
  }
}
</script>
 
<style lang="less" scoped>
.foot-print-box {
  height: 100vh;
  overflow: scroll;
  .foot-print {
    width: 355px;
    min-height: 145px;
    margin: 20px auto auto auto;
    background: #fff;
    .foot-print-top {
      display: flex;
      align-items: center;
        border-bottom: 1px solid #dcdee0;
        padding: 10px;
      .print-top-right {
          margin-left: 10px;
          font-size: 16px;
          font-weight: bold;
        .top-right-source {
          display: flex;
          margin-top: 5px;
          font-size: 12px;
          background: #fc6e0933;
          color: #fc6e09;
          // border: 1px solid #fc6e09;
          border-radius: 5px;
          span {
            display: block;
            padding: 5px;
          &:first-child{
            background: #fc6e09;
            color: #ffff;
            border-radius: 5px 0 0 5px;
          }
          }
        }
      }
    }
    .foot-print-bot{
        display: flex;
        padding: 10px;
        font-size: 13px;
        p{

            &:nth-child(1){
                width: 65px;
            }
            &:nth-child(2){
                width: calc(355px - 200px);
            }
            &:nth-child(3){
                width: 110px;
                text-align: center;
            }
        }
    }
    img {
      width: 80px;
      height: 80px;
    }
  }
}
</style>